wbApp.controller('TextsSettingsCtrl', ['$scope', '$q', '$translate', 'tenantSettingSvc', 'notificationSvc','tenantInfo',
function ($scope, $q, $translate, tenantSettingSvc, notificationSvc, tenantInfo) {

    var isActive = false;
    var loaded = false;

    $scope.isFranchiseCentral = tenantInfo.isFranchiseCentral;

    function loadData() {
        $scope.isBusy = true;
        $scope.tenantSetting = {};
        $scope.tenantSettingSrc = tenantSettingSvc.getAsync();
        $q.all([$scope.tenantSettingSrc.$promise]).then(function () {
            $scope.tenantSetting = angular.copy($scope.tenantSettingSrc);
            $scope.tenantSettingOrig = angular.copy($scope.tenantSettingSrc);

            $scope.isBusy = false;
        });
    }

    $scope.$on('refreshData', function (e, data) {
        if (isActive) {
            loadData();
        }
    });

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 9) {
            if (!isActive) {
                isActive = true;

                if (!loaded) {
                    loadData();
                    loaded = true;
                }
            }
        } else {
            isActive = false;
        }
    });

    $scope.onCancel = function () {
        loadData();
    }

    $scope.onModelSave = function (data) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        var updates = 0;

        if (!$scope.tenantSettingIsUnchanged(data)) {
            updates++;

            tenantSettingSvc.getAsync().$promise.then(function (currentSetting) {

                var current = angular.copy(currentSetting);

                // Apply only data we are setting in on this tab
                current.coursesMainPageButton = data.coursesMainPageButton;
                current.eventMainPageButton = data.eventMainPageButton;
                current.compensationsMainPageButton = data.compensationsMainPageButton;
                current.kidergartenMainPageButton = data.kidergartenMainPageButton;
                current.reservationsMainPageButton = data.reservationsMainPageButton;
                current.formsMainPageButton = data.formsMainPageButton;
                current.rentsMainPageButton = data.rentsMainPageButton;
                current.attendanceMainPageButton = data.attendanceMainPageButton;

                current.coursesMenuName = data.coursesMenuName;
                current.eventsMenuName = data.eventsMenuName;
                current.compensationsMenuName = data.compensationsMenuName;
                current.kidergartenMenuName = data.kidergartenMenuName;
                current.customContentTypeText = data.customContentTypeText;
                current.myKidergartenMenuName = data.myKidergartenMenuName;
                current.attendanceMenuName = data.attendanceMenuName;

                tenantSettingSvc.update(current, function (model) {
                    $scope.tenantSetting = angular.copy(model);
                    $scope.tenantSettingOrig = angular.copy(model);

                    updates--;
                    if (!updates) {
                        $scope.isSaving = false;
                    }
                }, function (errorResult) {
                    updates--;
                    if (!updates) {
                        $scope.isSaving = false;
                    }

                    notificationSvc.notifyError(
                        $translate.instant('TXT_ALERT_TITLE_ENTITY_SAVE_ERROR'),
                        notificationSvc.translateError(errorResult));
                });
            });
        }
    }

    $scope.tenantSettingIsUnchanged = function (data) {
        return angular.equals(data, $scope.tenantSettingOrig);
    }

    $scope.detailIsUnchanged = function (tenantSettingData) {
        return $scope.tenantSettingIsUnchanged(tenantSettingData);
    }

    $scope.onTriggerPortalUpdate = function () {
        tenantSettingSvc.triggerPortalUpdate();
    }
}]);
